import React from "react"
import { DatesHelper, } from "../datesHelper"
import { Period } from "../period"
import { RequiredSymbol } from "./various"
import { InputError } from "./inputError"
import { range } from "lodash";
import ReactDatePicker, { registerLocale } from "react-datepicker";
const it = require('date-fns/locale/it')
registerLocale('it', it)
import { formGroup } from "./formGroup"

export interface DatePickerProps {
    value?: Date;
    onSelectDate: (date: Date | null) => void;
    dateRange?: { from: Date; to: Date; };
    numberOfMonths?: number;
    readOnly?: boolean;
    className?: string;
    required?: boolean;
    placeHolder?: string;
    enableDates?: Date[];
    inline?: boolean;
}
export interface DatePickerComponentProps extends DatePickerProps {
    label?: string;
    error?: string;
}
interface DesktopDatePickerProps extends DatePickerProps {
    dayComponent?(dayOfMonth: number, date?: Date): React.ReactNode;
}
interface DesktopDatePickerComponentProps extends DesktopDatePickerProps {
    label?: string;
    error?: string;
}

export class DatePicker extends React.Component<DatePickerComponentProps>{
    render() {
        return <DesktopDatePicker {...this.props} />
    }
}

export class SimpleDatePicker extends React.Component<DatePickerProps>{
    private desktop: SimpleDesktopDatePicker;
    private mobile: SimpleMobileDatePicker;
    open() {
        if (this.desktop) this.desktop.open();
        else this.mobile.focus();
    }
    render() {
        return <SimpleDesktopDatePicker {...this.props} ref={dp => this.desktop = dp!} />
    }
}
export class DatePickerWithCalendar extends React.Component<DatePickerProps>{
    private datepicker: SimpleDatePicker;
    render() {
        return (
            <div className="input-group">
                {this.props.children}
                <SimpleDatePicker {...this.props} ref={datepicker => this.datepicker = datepicker!} />
                <button type="button"
                    className="btn btn-primary"
                    onClick={() => this.datepicker.open()}
                    disabled={this.props.readOnly} >
                    <span className="fas fa-calendar-alt" aria-hidden="true"></span>
                </button>
            </div>
        );
    }
}

export class SimpleDesktopDatePicker extends React.Component<DesktopDatePickerProps>{

    open = () => {
        this.calendar?.current?.setOpen(true, true);
    }

    private onKeyDown = (event: React.KeyboardEvent<HTMLDivElement>) => {
        if (event.key === "Tab")
            this.calendar?.current?.setOpen(false, true);
    };

    private onChangeData = (date: Date | null) => {
        this.props.onSelectDate(date && DatesHelper.ToDate(date));
    }

    calendar = React.createRef<ReactDatePicker>();
    render() {

        const { value, className, placeHolder, required, readOnly, dateRange, inline, enableDates, dayComponent } = this.props;

        return (<ReactDatePicker
            ref={this.calendar}
            onChange={this.onChangeData}
            className={"form-control ".concat(className || "")}
            placeholderText={placeHolder}
            disabled={readOnly}
            required={required}
            minDate={dateRange?.from}
            maxDate={dateRange?.to}
            includeDates={enableDates}
            selected={value && !isNaN(value.valueOf()) ? value : null}
            locale="it"
            dateFormat="dd/MM/yyyy"
            closeOnScroll
            onKeyDown={this.onKeyDown}
            renderDayContents={dayComponent}
            open={inline}
            inline={inline}
            strictParsing
            disabledKeyboardNavigation
            showMonthDropdown
            showYearDropdown
            dropdownMode="select"
        />);
    }
}




export class SimpleMobileDatePicker extends React.Component<DatePickerProps>{
    private input = React.createRef<HTMLInputElement>();

    private sendDate = (selectedDate: Date | null) => {
        selectedDate ? this.props.onSelectDate(DatesHelper.ToDate(selectedDate)) : this.props.onSelectDate(null);
    }

    focus = () => {
        this.input.current?.focus();
    }

    private onChangeTextValue = (e: React.FormEvent<HTMLInputElement>) => {
        var value = (e.target as any).value as string;
        if (!value || value === "") {
            this.sendDate(null);
        }
        else {
            const d = new Date(value);
            if (!isNaN(d.valueOf())) {
                if (!this.props.dateRange || Period.Create(this.props.dateRange.from, this.props.dateRange.to).contains(d))
                    this.sendDate(d);
                else
                    this.sendDate(null);

            }
            else
                this.sendDate(null);
        }
    }
    render() {
        return (
            <input type="date" ref={this.input}
                min={this.props.dateRange && DatesHelper.ToInputDateFormat(this.props.dateRange.from)}
                max={this.props.dateRange && DatesHelper.ToInputDateFormat(this.props.dateRange.to)}
                className="form-control"
                disabled={this.props.readOnly}
                onChange={this.onChangeTextValue}
                placeholder={this.props.placeHolder}
                value={this.props.value ? DatesHelper.ToInputDateFormat(this.props.value) : ""}
                required={this.props.required}
            />
        );
    }
}

export class MobileDatePicker extends React.Component<DatePickerComponentProps>{
    render() {
        const { label, error, ...props } = this.props;
        return (
            <div style={{ marginBottom: 10 }}>
                <label className="form-label">{this.props.label}</label>
                <div>
                    <SimpleMobileDatePicker {...props} />
                </div>
                <InputError error={error} />
            </div>);
    }
}


export class DesktopDatePicker extends React.Component<DesktopDatePickerComponentProps>{
    simpleDatePicker: SimpleDesktopDatePicker;

    open = () => {
        this.simpleDatePicker.open();
    }

    render() {
        return (
            <div className="w-100">
                {this.props.label && <label className="form-label">{this.props.label}</label>}
                <div className="input-group" style={{ flexWrap: "nowrap" }}>
                    <SimpleDesktopDatePicker {...this.props} ref={datePicker => this.simpleDatePicker = datePicker!} />
                    {
                        !this.props.inline && <button type="button"
                            className="btn btn-primary"
                            disabled={this.props.readOnly}
                            onClick={this.open} >
                            <span className="fas fa-calendar-alt" aria-hidden="true"></span>
                        </button>
                    }
                </div>
                <InputError error={this.props.error} />
            </div>);
    }
}


export interface ComboDatePickerProps {
    label?: string;
    value?: Date;
    onSelectDate: (date: Date | null) => void;
    dateRange?: Period;
    readOnly?: boolean;
    error?: string;
    dayPlaceholder?: string;
    monthPlaceholder?: string;
    yearPlaceholder?: string;
    mandatory?: boolean;
    hl: string;
    hideDay?: boolean;
    required?: boolean;
}

export interface ComboDatePickerState {
    day: number | null;
    month: number | null;
    year: number | null;
}

interface MonthSelectorProps {
    onChange: (month: number) => void;
    selectedMonth: number | null;
    minMonth?: number;
    maxMonth?: number;
    placeholder?: string;
    disabled?: boolean;
    required?: boolean;
    allowNulls?: boolean;
    hl: string;
}

export class MonthSelector extends React.PureComponent<MonthSelectorProps>{
    private onChange = (e: React.FormEvent<HTMLSelectElement>) => {
        let month = +(e.target as any).value;
        this.props.onChange(month);
    }

    render() {
        return (
            <select className="form-control"
                disabled={this.props.disabled}
                required={this.props.required}
                onChange={this.onChange}
                value={this.props.selectedMonth != null ? this.props.selectedMonth.toString() : undefined}>
                <option style={{ display: this.props.allowNulls ? "" : "none" }} key={-1} disabled={this.props.allowNulls} value="">{this.props.placeholder}</option>
                {range(
                    this.props.minMonth != undefined ? this.props.minMonth : 0,
                    (this.props.maxMonth != undefined ? this.props.maxMonth : 11) + 1)
                    .map(month => <option key={month} value={month.toString()}>{DatesHelper.getMonthName(new Date(2017, month), this.props.hl!)}</option>)}
            </select>);
    }
}


export interface YearSelectorProps {
    onChange: (year: number) => void;
    selectedYear: number | null;
    minYear: number;
    maxYear: number;
    placeholder?: string;
    disabled?: boolean;
    required?: boolean;
    allowNulls?: boolean;
}

export class YearSelector extends React.PureComponent<YearSelectorProps>{
    onChange = (e: React.FormEvent<HTMLSelectElement>) => {
        let year = +(e.target as any).value;
        this.props.onChange(year);
    }

    render() {
        return (
            <select className="form-control"
                disabled={this.props.disabled}
                required={this.props.required}
                onChange={this.onChange}
                value={this.props.selectedYear != null ? this.props.selectedYear.toString() : undefined}>
                <option style={{ display: this.props.allowNulls ? "" : "none" }} key={-1} disabled={this.props.allowNulls} value="">{this.props.placeholder}</option>
                {range(this.props.minYear, this.props.maxYear + 1).map(year => <option key={year} value={year.toString()}>{year}</option>)}
            </select>);
    }
}

export class ComboDatePicker extends React.Component<
    ComboDatePickerProps,
    ComboDatePickerState
> {
    constructor(props: ComboDatePickerProps) {
        super(props);
        this.state = {
            year: null,
            month: null,
            day: null
        }
    }

    componentDidMount() {
        if (this.props.value) {
            const day = this.props.value.getDate();
            const month = this.props.value.getMonth();
            const year = this.props.value.getFullYear();
            this.setState({ day, month, year });
        }
        if (this.props.hideDay) this.setState({ day: 1 });
    }

    private fixDate(year: number, month: number, day: number) {
        var date = new Date(year, month, day);
        if (
            this.props.dateRange &&
            date.valueOf() > this.props.dateRange.to.valueOf()
        )
            date = this.props.dateRange.to;
        if (
            this.props.dateRange &&
            date.valueOf() < this.props.dateRange.from.valueOf()
        )
            date = this.props.dateRange.from;
        return date;
    }

    private onChangeDay = (e: React.FormEvent<HTMLSelectElement>) => {
        e.preventDefault();
        const day = +(e.target as any).value;
        this.setState({ day });
        if (
            day != null &&
            this.state.month != null &&
            this.state.year != null
        ) {
            this.props.onSelectDate(this.fixDate(this.state.year, this.state.month, day));
        } else {
            this.props.onSelectDate(null);
        }
    };

    private onChangeMonth = (month: number) => {
        this.setState({ month });
        if (
            this.state.day != null &&
            month != null &&
            this.state.year != null
        ) {
            this.props.onSelectDate(this.fixDate(this.state.year, month, this.state.day));
        } else {
            this.props.onSelectDate(null);
        }
    };

    private onChangeYear = (year: number) => {
        this.setState({ year });
        if (
            this.state.day != null &&
            this.state.month != null &&
            year != null
        ) {
            this.props.onSelectDate(this.fixDate(year, this.state.month, this.state.day));
        } else {
            this.props.onSelectDate(null);
        }
    };

    componentWillReceiveProps({ value }: ComboDatePickerProps) {
        if (value) {
            const day = value.getDate();
            const month = value.getMonth();
            const year = value.getFullYear();
            this.setState({ day, month, year });
        }
    }

    private isMandatory() {
        return this.props.mandatory === undefined || this.props.mandatory === false;
    }

    private year = (style: React.CSSProperties, cols: number) => {
        var minYear = (this.props.dateRange && this.props.dateRange.from.getFullYear()) || 1901;
        var maxYear = (this.props.dateRange && this.props.dateRange.to.getFullYear()) || 2029;
        return (
            <div key="year" className={"col-".concat(cols.toString()).concat(this.props.error ? " has-error" : "")} style={style}>
                <YearSelector
                    minYear={minYear}
                    maxYear={maxYear}
                    placeholder={this.props.yearPlaceholder}
                    selectedYear={this.state.year}
                    onChange={this.onChangeYear}
                    required={this.props.required}
                    disabled={this.props.readOnly}
                    allowNulls={this.state.year != null && this.isMandatory()} />
            </div>);
    }


    private month = (style: React.CSSProperties, cols: number) => {
        var minMonth = 0;
        var maxMonth = 11;
        if (this.props.dateRange) {
            if (this.state.year === this.props.dateRange.from.getFullYear()) {
                minMonth = this.props.dateRange.from.getMonth();
            }
            if (this.state.year === this.props.dateRange.to.getFullYear()) {
                maxMonth = this.props.dateRange.to.getMonth();
            }
        }

        return (
            <div key="month" className={"col-".concat(cols.toString()).concat(this.props.error ? " has-error" : "")} style={style}>
                <MonthSelector
                    minMonth={minMonth}
                    maxMonth={maxMonth}
                    selectedMonth={this.state.month}
                    placeholder={this.props.monthPlaceholder}
                    onChange={this.onChangeMonth}
                    required={this.props.required}
                    disabled={this.props.readOnly}
                    hl={this.props.hl}
                    allowNulls={this.state.month != null && this.isMandatory()} />
            </div>);
    }

    private day = (style: React.CSSProperties, cols: number) => {
        var minDay = 1;
        var maxDay = (DatesHelper.daysInMonth(this.state.year, this.state.month) || 31);
        if (this.props.dateRange) {
            if (this.state.year === this.props.dateRange.from.getFullYear() && this.state.month == this.props.dateRange.from.getMonth()) {
                minDay = this.props.dateRange.from.getDate();
            }
            if (this.state.year === this.props.dateRange.to.getFullYear() && this.state.month == this.props.dateRange.to.getMonth()) {
                maxDay = this.props.dateRange.to.getDate();
            }
        }

        return (<div key="day" className={"col-".concat(cols.toString()).concat(this.props.error ? " has-error" : "")} style={style}>
            <select className="form-control"
                disabled={this.props.readOnly}
                required={this.props.required}
                onChange={this.onChangeDay}
                value={this.state.day ? this.state.day.toString() : undefined}>
                <option key={-1} disabled={this.state.day != null && this.isMandatory()} value="">{this.props.dayPlaceholder}</option>
                {range(minDay, maxDay + 1).map(day => <option key={day} value={day.toString()}>{day}</option>)}
            </select>
        </div>);
    }

    static first: React.CSSProperties = { marginRight: 0, paddingRight: 0 };
    static middle: React.CSSProperties = { marginLeft: 0, paddingLeft: 0, marginRight: 0, paddingRight: 0 };
    static last: React.CSSProperties = { marginLeft: 0, paddingLeft: 0 };

    render() {
        const cols = this.props.hideDay === true ? 6 : 4;

        if (this.props.hl == "en")
            if (this.props.hideDay) {
                var list = [this.month(ComboDatePicker.first, cols), this.year(ComboDatePicker.last, cols)];
            }
            else {
                var list = [this.month(ComboDatePicker.first, cols), this.day(ComboDatePicker.middle, cols), this.year(ComboDatePicker.last, cols)];
            }
        else if (this.props.hl == "it") {
            if (this.props.hideDay) {
                var list = [this.month(ComboDatePicker.first, cols), this.year(ComboDatePicker.last, cols)];
            }
            else {
                var list = [this.day(ComboDatePicker.first, cols), this.month(ComboDatePicker.middle, cols), this.year(ComboDatePicker.last, cols)];
            }
        }
        else {
            if (this.props.hideDay) {
                var list = [this.year(ComboDatePicker.first, cols), this.month(ComboDatePicker.last, cols)];
            }
            else {
                var list = [this.year(ComboDatePicker.first, cols), this.month(ComboDatePicker.middle, cols), this.day(ComboDatePicker.last, cols)];
            }
        }

        var label = this.props.label ? <label className="form-label">{this.props.label}</label> : undefined;
        var required = this.props.required ? <RequiredSymbol /> : undefined;

        return (
            <div className="">
                {label} {required}
                <div className="row">
                    {list}
                </div>
                {this.props.children}
                <InputError error={this.props.error} />
            </div>
        );
    }
}

export const DatePickerForms = formGroup(DatePicker);export default DatePicker;